import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangePipe } from './pipe/range';
import { AgePipe } from './pipe/age';
import { SafeHtmlPipe } from './pipe/safe-html';
import { SafeUrlPipe } from './pipe/safe-url';
import { SafeResourceUrlPipe } from './pipe/safe-resource-url';
import { SafeStylePipe } from './pipe/safe-style';
import { NativeMouseenterDirective } from './directive/native-mouseenter';
import { NativeMouseleaveDirective } from './directive/native-mouseleave';
import { LazyLoadSrcDirective } from './directive/lazy-load-src.directive';
import { TypographPipe } from './pipe/typograph';
import { NormalizeLinkDomainForOsmi } from './pipe/normalize-link-domain-for-osmi';
import { NativePointerenterDirective } from './directive/native-pointerenter';
import { NativePointerleaveDirective } from './directive/native-pointerleave';
import { CamelCasePipe } from './pipe/camel-case';

@NgModule({
  imports: [CommonModule],
  declarations: [
    RangePipe,
    AgePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeResourceUrlPipe,
    SafeStylePipe,
    NativeMouseenterDirective,
    NativeMouseleaveDirective,
    NativePointerenterDirective,
    NativePointerleaveDirective,
    LazyLoadSrcDirective,
    TypographPipe,
    NormalizeLinkDomainForOsmi,
    CamelCasePipe,
  ],
  exports: [
    RangePipe,
    AgePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeResourceUrlPipe,
    SafeStylePipe,
    NativeMouseenterDirective,
    NativeMouseleaveDirective,
    NativePointerenterDirective,
    NativePointerleaveDirective,
    LazyLoadSrcDirective,
    TypographPipe,
    NormalizeLinkDomainForOsmi,
    CamelCasePipe,
  ],
})
export class SkyMiscModule {}
